if (!customElements.get('td-ingredient-modal')) {
  class TDIngredientModal extends HTMLElement {
    #abortController = null;
    #dialog = null;
    #trigger = null;
    #previousFocus = null;
    #previousBodyOverflow = '';
    #scrollLocked = false;
    #focusFrame = null;

    connectedCallback() {
      this.#abortController = new AbortController();
      this.#dialog = this.querySelector('[data-td-ingredient-modal-dialog]');
      this.#trigger = this.querySelector('[data-td-ingredient-modal-open]');
      const { signal } = this.#abortController;

      this.#trigger?.addEventListener('click', this.#open, { signal });
      this.querySelectorAll('[data-td-ingredient-modal-close]').forEach((button) => {
        button.addEventListener('click', this.#close, { signal });
      });
      this.#dialog?.addEventListener('cancel', this.#handleCancel, { signal });
      this.#dialog?.addEventListener('click', this.#handleDialogClick, { signal });
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      this.#abortController = null;
      if (this.#focusFrame) cancelAnimationFrame(this.#focusFrame);
      this.#focusFrame = null;
      this.#close();
    }

    #open = () => {
      if (!this.#dialog || this.#dialog.open) return;

      this.#previousFocus = document.activeElement;
      this.#previousBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.#scrollLocked = true;
      this.#dialog.showModal();
      this.#trigger?.setAttribute('aria-expanded', 'true');
      this.#focusFrame = requestAnimationFrame(() => {
        this.#focusFrame = null;
        this.querySelector('[data-td-ingredient-modal-close]')?.focus({ preventScroll: true });
      });
    };

    #close = () => {
      if (this.#dialog?.open) this.#dialog.close();
      this.#trigger?.setAttribute('aria-expanded', 'false');
      if (this.#scrollLocked) {
        document.body.style.overflow = this.#previousBodyOverflow;
        this.#scrollLocked = false;
      }

      if (this.#previousFocus instanceof HTMLElement && this.#previousFocus.isConnected) {
        this.#previousFocus.focus({ preventScroll: true });
      }
      this.#previousFocus = null;
    };

    #handleCancel = (event) => {
      event.preventDefault();
      this.#close();
    };

    #handleDialogClick = (event) => {
      if (event.target === this.#dialog) this.#close();
    };
  }

  customElements.define('td-ingredient-modal', TDIngredientModal);
}
